import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';

type UpdateGroups = {
  comID: string;
  groupId: string;
};

export const updateGroups = ({ comID, groupId }: UpdateGroups): void => {
  const endPoint = PAYMENTS_BACKEND_URL + 'groups/' + groupId;
  axios
    .put(endPoint, { comID: comID })
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }
      return true;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};
